const testimonialsTextData = {
  en: {
    'landing.testimonials.title1': 'TESTIMONIALS',
    'landing.testimonials.title2': 'See what our clients are saying',
    'landing.testimonials.cta': 'See all testimonials'
  },
  es: {
    'landing.testimonials.title1': 'TESTIMONIOS',
    'landing.testimonials.title2': 'Conoce lo que nuestros clientes dicen',
    'landing.testimonials.cta': 'Ver todos los testimonios'
  },
};

export default testimonialsTextData;
